import { Component } from '@angular/core';
import { YOUTUBE_PLAYER_CONFIG } from '@angular/youtube-player';
import { PageheaderComponent } from '../../../../Components/pageheader/pageheader.component';
import { IPageHeader } from '../../../../Components/pageheader/pageHeader.model';
import { PhotoGalleryComponent } from '../../../../Components/photogallery/photogallery.component';
import { YoutubePlayerComponent } from '../../../../Components/youtube-player/youtube-player.component';
import { BAC_ABOUT_DATA } from '../bac-about.data';

@Component({
  selector: 'app-bac-tour',
  standalone: true,
  imports: [PageheaderComponent, PhotoGalleryComponent, YoutubePlayerComponent],
  providers: [
    {
      provide: YOUTUBE_PLAYER_CONFIG,
      useValue: {
        disablePlaceholder: true,
      },
    },
  ],
  templateUrl: './bac-tour.component.html',
})
export class BacTourComponent {
  public pageOptions: IPageHeader = {
    mainPage: { title: 'about_us', path: '/about' },
    children: [{ title: 'school_tour', path: null }],
  };

  public TOUR_DATA = BAC_ABOUT_DATA.tour;
}
